var map = {
	"./Company.vue": [
		"8799",
		"chunk-61c2073a"
	],
	"./Home.vue": [
		"bb51",
		"chunk-030a57af"
	],
	"./Info.vue": [
		"2469",
		"chunk-20862719"
	],
	"./Service.vue": [
		"e2f8",
		"chunk-ba66c770"
	],
	"./news/20210426.vue": [
		"ff65",
		"chunk-11d3b8bc"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;